import React, { useEffect, useState } from 'react';
import Utils from '../../../../common/utils/Utils';
import { connect } from 'react-redux';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import InstrumentSummary from './InstrumentSummary';
import { getInstrumentsList } from './InstrumentSummary.actions';

function InstrumentSummaryContainer(props) {
  const [instruments, setInstruments] = useState([]);

  useEffect(() => {
    getInstrumentsList().then((res) => {
      let r = res.body;
      if (!r.Data || !r.Display) {
        return;
      }

      setInstruments(r.Data.slice(0));
    });
  }, []);

  const _determineCurrentPath = () => Utils.determineCurrentPath(props.location.pathname);

  const _onChange = (path) => {
    const { navigate, instrument } = props;
    navigate(`/instrument-details/${instrument.SerialNumber}${path}`);
  };

  const _onChangeInstrumentSelection = (selectedInstrument) => {
    if (selectedInstrument == null) return;

    const { navigate, instrument } = props;
    let currentUrl = props.location.pathname + props.location.search;
    let newUrl = currentUrl.replaceAll(instrument.SerialNumber, selectedInstrument.SerialNumber);

    navigate(newUrl);
  };

  return (
    <InstrumentSummary
      {...props}
      currentPath={_determineCurrentPath()}
      onChange={_onChange}
      instruments={instruments}
      onChangeInstrumentSelection={_onChangeInstrumentSelection}
    />
  );
}

const mapStateToProps = (state) => ({
  globalSettings: state.user ? state.user.Settings : undefined,
});

export default withRouter(connect(mapStateToProps)(InstrumentSummaryContainer));
